import { parameterForceRequote } from 'pu-data/Utils';

import { CHANGE_PARAMETER, QUOTE_SUCCESS } from 'pu-redux/actions/QuoteActions';

const parametersChanged = (state = false, action) => {
  switch (action.type) {
    case CHANGE_PARAMETER:
      return parameterForceRequote(action.name);

    case QUOTE_SUCCESS:
      return false;

    // case SELECT_PRICE_SUCCESS:
    //   return false;

    default:
      return state;
  }
};

export default parametersChanged;
